<template>
  <div class="site-page">
    <Header />
    <main>
      <Banner />
      <Home />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "./Header/index.vue";
import Home from "./Home/index.vue";
import Footer from "./Footer/index.vue";
import Banner from "./Banner/index.vue";

export default {
  name: "Main",
  components: {
    Header,
    Home,
    Footer,
    Banner,
  },
};
</script>

<style lang="less" scoped>
.site-page {
  min-height: 100vh;
  background: #f6f8fb;
}

main {
  overflow: hidden;
}
</style>
